import React, { useState } from "react";
import ButtonCompo from "./ButtonCompo";
import { Popover } from "@mui/material";

function PopOverBox({ trigger, dataArray }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event?.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <div onClick={handleClick} className="cursor-pointer">
        {trigger}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
        }}
      >
        <div className="w-full flex flex-col p-2">
          {dataArray?.map((e, i) => (
            <section key={i} onClick={handleClose}>{e}</section>
          ))}
        </div>
      </Popover>
    </div>
  );
}

export default PopOverBox;
